import { useDrag, DragPreviewImage } from "react-dnd";
import PropTypes from 'prop-types';

function getStyles(isDragging) {
    return {
        opacity: isDragging ? 0 : 1,
    };
}

// Transparent pixel as a custom preview image
const transparentPixel = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";

const DragLatter = ({ item, alphabetType, index, callback }) => {
    const [{ isDragging }, dragRef, previewRef] = useDrag({
        type: alphabetType,
        item: () => ({ ...item, index }),
        end: () => callback(index, "inDragMode", 0),
        collect: (monitor) => ({
            isDragging: monitor.isDragging(),
        }),
    });

    const onDragStart = () => {
        callback(index, "inDragMode", 1);
    };

    return (
        <>
            <DragPreviewImage connect={previewRef} src={transparentPixel} />
            
            <img
                src={item[0]?.image}
                data-index={index}
                ref={dragRef}
                onDragStart={onDragStart}
                onTouchStart={() => callback(index, "inDragMode", 1)}
                onTouchEnd={() => callback(index, "inDragMode", 0)}
                style={getStyles(isDragging)}
                alt=""
            />
        </>
    );
};

DragLatter.propTypes = {
    item: PropTypes.arrayOf(
        PropTypes.shape({
            image: PropTypes.string.isRequired,
        })
    ).isRequired,
    alphabetType: PropTypes.string.isRequired,
    index: PropTypes.number.isRequired,
    callback: PropTypes.func.isRequired,
};

export default DragLatter;

